<form [formGroup]="carGroup" (submit)="submit()">
  <wz-content-loader *ngIf="isFillingForm; else contentTmp"
    >Chargement des données du véhicules</wz-content-loader
  >
  <ng-template #contentTmp>
    <div *ngIf="!isEditMode && confirmedVehicle" class="viewer">
      <wz-immatriculation
        [disabled]="true"
        [value]="confirmedVehicle.immatriculation ?? ''"
        [zipCode]="zipCode"
      >
      </wz-immatriculation>
      <wz-car-viewer [car]="confirmedVehicle"></wz-car-viewer>
      <button
        type="button"
        mat-raised-button
        color="accent"
        (click)="goEditMode()"
      >
        Modifier le véhicule
      </button>
    </div>

    <ng-container *ngIf="isEditMode">
      <wz-form-group-part>
        <wz-form-group-part-header>
          <mat-icon>info</mat-icon>Plaque d'immatriculation du véhicule
        </wz-form-group-part-header>
        <!-- IMMAT + SEARCH -->
        <wz-immatriculation
          formControlName="immatriculation"
          [zipCode]="zipCode"
        ></wz-immatriculation>
      </wz-form-group-part>

      <wz-form-group-part *ngIf="searchByTypeMine">
        <wz-form-group-part-header>
          <mat-icon>search</mat-icon>Recherche par type mine
        </wz-form-group-part-header>
        <mat-form-field>
          <wz-text-input
            placeholder="Filtrer par type mine"
            [formControl]="typeMineCtrl"
          ></wz-text-input>
        </mat-form-field>
      </wz-form-group-part>

      <wz-form-group-part>
        <div
          class="searching-by-immat animated fadeIn"
          *ngIf="isSearchingByImmat"
        >
          Nous recherchons le véhicule...
        </div>
        <div
          class="search-result"
          *ngIf="
            hasImmatChanged && !isSearchingByImmat && immatriculationCtrl.valid
          "
        >
          <div class="search" *ngIf="!isFormShown; else updateTmp">
            <div class="search-ko" *ngIf="!proposedVehicle">
              <div class="search-header">
                <mat-icon>search</mat-icon>Nous n'avons pas trouvé le véhicule,
                veuillez le saisir manuellement
              </div>
            </div>
          </div>
          <ng-template #updateTmp>
            <div class="update">
              <div class="search-ok" *ngIf="proposedVehicle">
                <div class="search-header">
                  <mat-icon color="warn">warning</mat-icon>Est-ce le bon
                  véhicule recherché ?
                </div>
                <wz-car-viewer [car]="proposedVehicle"></wz-car-viewer>
                <div class="buttons">
                  <button
                    mat-raised-button
                    color="warn"
                    (click)="doNotUseNewProposedVehicle()"
                  >
                    <mat-icon>clear</mat-icon>Non
                  </button>
                  <button
                    mat-raised-button
                    color="primary"
                    (click)="validateProposedVehicle()"
                  >
                    <mat-icon>check</mat-icon>Oui
                  </button>
                </div>
              </div>
              <div class="search-ko" *ngIf="!proposedVehicle">
                <div class="search-header">
                  <mat-icon color="warn">warning</mat-icon>Aucun véhicule
                  correspondant
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </wz-form-group-part>
      <wz-form-group-part *ngIf="isFormShown">
        <wz-form-group-part-header>
          <mat-icon color="accent">calendar_today</mat-icon>Date d'achat et date
          de mise en circulation
        </wz-form-group-part-header>
        <div class="car-form">
          <mat-form-field class="dateMiseEnCirculation">
            <wz-date-input
              placeholder="Date de mise en circulation"
              formControlName="dateMiseEnCirculation"
            >
            </wz-date-input>
            <mat-error *ngIf="dateMiseEnCirculationCtrl.hasError('max')"
              >La date de mise en circulation ne peut être postérieure à la date
              d’aujourd’hui</mat-error
            >
            <mat-hint> <span wzI18n="FORMS_DATE_HINT"></span> </mat-hint>
          </mat-form-field>

          <mat-form-field>
            <wz-date-input
              placeholder="Date d'achat"
              formControlName="dateAchatVehicule"
            ></wz-date-input>
            <mat-error *ngIf="dateAchatVehiculeCtrl.hasError('min')"
              >La date d’achat du véhicule ne peut être antérieure à la date de
              mise en circulation</mat-error
            >
            <mat-error
              *ngIf="
                !dateAchatVehiculeCtrl.hasError('min') &&
                dateAchatVehiculeCtrl.hasError('max')
              "
            >
              <span *ngIf="dateAchatDaysInFutureAllowed > 0; else todayTmp">
                La date d'achat ne peut être postérieure à dans
                {{ dateAchatDaysInFutureAllowed }} jours
              </span>
              <ng-template #todayTmp
                >La date d'achat ne peut être postérieure à la date
                d’aujourd’hui</ng-template
              >
            </mat-error>
            <mat-hint> <span wzI18n="FORMS_DATE_HINT"></span> </mat-hint>
          </mat-form-field>
        </div>
      </wz-form-group-part>
      <wz-form-group-part *ngIf="isFormShown">
        <!-- CAR FORM-->
        <wz-form-group-part-header>
          <wz-icon color="accent">car</wz-icon>Détail du véhicule
        </wz-form-group-part-header>
        <div class="car-form">
          <mat-form-field>
            <wz-select2
              placeholder="La marque du véhicule"
              formControlName="marque"
              [items]="marqueListInfo.list"
              [isLoading]="marqueListInfo.isLoading"
            ></wz-select2>
            <mat-hint *ngIf="marqueListInfo.isLoading"
              >Chargement des marques</mat-hint
            >
            <mat-hint *ngIf="shouldDisplayHint(marqueListInfo)">{{
              getListHint(marqueListInfo, 'marque')
            }}</mat-hint>
          </mat-form-field>

          <mat-form-field *ngIf="marqueCtrl?.valid">
            <wz-select2
              placeholder="Le modèle du véhicule"
              formControlName="modele"
              [items]="modeleListInfo.list"
              [isLoading]="modeleListInfo.isLoading"
            ></wz-select2>
            <mat-hint *ngIf="modeleListInfo.isLoading"
              >Chargement des modèles</mat-hint
            >
            <mat-hint *ngIf="shouldDisplayHint(modeleListInfo)">{{
              getListHint(modeleListInfo, 'modèle')
            }}</mat-hint>
          </mat-form-field>

          <mat-form-field *ngIf="modeleCtrl?.valid">
            <wz-select2
              placeholder="Energie du véhicule"
              formControlName="energie"
              [items]="energieListInfo.list"
              [isLoading]="energieListInfo.isLoading"
            ></wz-select2>
            <mat-hint *ngIf="energieListInfo.isLoading"
              >Chargement des type d'énergies</mat-hint
            >
            <mat-hint *ngIf="shouldDisplayHint(energieListInfo)"
              >{{ getListHint(energieListInfo, 'énergie') }}
            </mat-hint>
          </mat-form-field>

          <mat-form-field *ngIf="energieCtrl?.valid">
            <wz-select2
              placeholder="Chevaux fiscaux du véhicule"
              formControlName="chevauxFiscaux"
              [items]="chevauxFiscauxListInfo.list"
              [isLoading]="chevauxFiscauxListInfo.isLoading"
            ></wz-select2>
            <mat-hint *ngIf="chevauxFiscauxListInfo.isLoading"
              >Chargement de la liste</mat-hint
            >
            <mat-hint *ngIf="shouldDisplayHint(chevauxFiscauxListInfo)">{{
              getListHint(chevauxFiscauxListInfo, 'puissance')
            }}</mat-hint>
          </mat-form-field>

          <mat-form-field *ngIf="chevauxFiscauxCtrl?.valid">
            <wz-select2
              placeholder="Carrosserie du véhicule"
              formControlName="carrosserie"
              [items]="carrosserieListInfo.list"
              [isLoading]="carrosserieListInfo.isLoading"
            ></wz-select2>
            <mat-hint *ngIf="carrosserieListInfo.isLoading"
              >Chargement des types de carrosserie</mat-hint
            >
            <mat-hint *ngIf="shouldDisplayHint(carrosserieListInfo)">{{
              getListHint(carrosserieListInfo, 'carrosserie')
            }}</mat-hint>
          </mat-form-field>

          <mat-form-field *ngIf="carrosserieCtrl?.valid">
            <wz-select2
              panelClass="wide version-select"
              placeholder="Version du véhicule"
              formControlName="version"
              [items]="versionListInfo.list"
              [isLoading]="versionListInfo.isLoading"
            >
              <ng-template let-item>
                <div class="version-select-item">
                  <div class="semi-bold">
                    {{ item.value.version }}
                  </div>
                  <div class="italic" *ngIf="item.value.typeMine">
                    Type mine : {{ item.value.typeMine }}
                  </div>
                  <div class="italic" *ngIf="!item.value.typeMine">
                    Type mine : non défini
                  </div>
                </div>
              </ng-template>
            </wz-select2>
            <mat-hint *ngIf="versionListInfo.isLoading"
              >Chargement des versions</mat-hint
            >
            <mat-hint *ngIf="shouldDisplayHint(versionListInfo)"
              >{{ getListHint(versionListInfo, 'version') }}
            </mat-hint>
          </mat-form-field>
        </div>

        <div class="buttons final-buttons">
          <button
            type="button"
            mat-button
            *ngIf="confirmedVehicle"
            color="warn"
            (click)="cancelEdit()"
          >
            Annuler
          </button>
          <button
            type="submit"
            [disabled]="carGroup.invalid"
            mat-raised-button
            color="primary"
          >
            Valider le véhicule
          </button>
        </div>
      </wz-form-group-part>
    </ng-container>
  </ng-template>
</form>
